import React from "react";
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip, Title, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card } from "../general/card";
import Loader from "../general/loader";
import { AlertColors } from "../alerting/alert_enums";
import { useTheme } from "@mui/material";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title, Legend);

export default function SiteQualityRating({ data, isFetching }) {
  const labels = data?.site_quality_rating ? data?.site_quality_rating.map((item) => item.DATE) : null;

  const rawDatasets = [
    {
      label: "Quality Score",
      data: data?.site_quality_rating ? data.site_quality_rating.map((item) => item.QUALITY_SCORE) : null,
      backgroundColor: data?.site_quality_rating
        ? data.site_quality_rating.map((item) =>
            item.QUALITY_SCORE > 75
              ? AlertColors.SUCCESS
              : item.QUALITY_SCORE > 50
                ? AlertColors.WARNING
                : AlertColors.ERROR,
          )
        : AlertColors.ERROR,
      maxBarThickness: 50,
    },
  ];

  const datasets = rawDatasets.filter(
    (dataset) => Array.isArray(dataset.data) && dataset.data.some((value) => value !== null && value !== undefined),
  );

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: false,
        text: "Daily Site Quality Rating",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Score",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <Card title="Site Quality Rating">
      {isFetching ? (
        <Loader />
      ) : (
        <div>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
